import React from "react";

const EditAlert = () => {
  return <div>This is EditAlert</div>;
};

export default EditAlert;
